import { ListeColumnType, ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React from 'react';
import { useLocation } from 'react-router';

import { ETATS_FACTURE } from '@/constants';
import { RegieContext } from '@/contexts';
import type { CycleType } from '@/types';

type FacturesListeTableHeaderGlobaleProps = {
  cycles?: CycleType[];
  [key: string]: any;
};

const FacturesListeTableHeaderGlobale = (props: FacturesListeTableHeaderGlobaleProps) => {
  const { cycles, ...rest } = props;

  const cyclesTitres = React.useMemo(() => _.map(cycles, ({ titre }) => titre), [cycles]);

  // récupère les paramètres sur la route (si jamais on a cliqué sur un cycle)
  const { state } = useLocation();
  const { identifiantsCycles: defaultIdentifiantsCycles } = (state || {
    identifiantsCycles: null,
  }) as {
    identifiantsCycles: number[];
  };

  const { regies, selectedRegie } = React.useContext(RegieContext);

  const { logicielsFacturier } = _.find(regies, { identifiant: selectedRegie }) || {};

  // Si 1 seul logiciel facturier, on masque la colonne
  const hideSourceColumn = _.size(logicielsFacturier) <= 1;

  return (
    <>
      <ListeTable.Column
        {...rest}
        name="numero"
        sortable
        verticalAlign="middle"
        style={{ width: 150 }}
      >
        N°
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="nomPayeur" sortable verticalAlign="middle">
        Nom du payeur
      </ListeTable.Column>
      <ListeTable.Column name="adresseFacturation" verticalAlign="middle">
        Adresse de
        <br />
        facturation
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="cycleFacturation"
        type={ListeColumnType.STRING}
        sortable
        verticalAlign="middle"
        filtersDefaultActive="DANS_LISTE"
        filtersValues={{
          DANS_LISTE: cyclesTitres,
        }}
        {...(!_.isEmpty(defaultIdentifiantsCycles) && {
          filtersDefaultValues: {
            DANS_LISTE: _.map(
              defaultIdentifiantsCycles,
              (identifiantCycle) => _.find(cycles, { identifiant: identifiantCycle })?.titre,
            ),
          },
        })}
      >
        Cycle de
        <br />
        facturation
      </ListeTable.Column>
      {!hideSourceColumn && (
        <ListeTable.Column
          {...rest}
          name="source"
          type={ListeColumnType.STRING}
          sortable
          style={{ width: 90 }}
          verticalAlign="middle"
          filtersDefaultActive="DANS_LISTE"
          filtersValues={{
            DANS_LISTE: _.map(logicielsFacturier, ({ code }) => code),
          }}
        >
          App
        </ListeTable.Column>
      )}
      <ListeTable.Column
        {...rest}
        name="dateFacture"
        sortable
        verticalAlign="middle"
        style={{ width: 120 }}
      >
        Date
        <br />
        limite
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="montant"
        sortable
        style={{ width: 130 }}
        verticalAlign="middle"
      >
        Montant
        <br />
        facture
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="montantEncaisse"
        type={ListeColumnType.NUMBER}
        sortable
        style={{ width: 130 }}
        verticalAlign="middle"
      >
        Montant
        <br />
        encaissé
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="etat"
        type={ListeColumnType.STRING}
        sortable
        verticalAlign="middle"
        style={{ width: 200 }}
        filtersDefaultActive="DANS_LISTE"
        filtersValues={{
          DANS_LISTE: [
            ETATS_FACTURE.ENCAISSEE,
            ETATS_FACTURE.A_ENCAISSER,
            ETATS_FACTURE.ENCAISSEMENT_PARTIEL,
            ETATS_FACTURE.IMPAYE_PARTIEL,
            ETATS_FACTURE.IMPAYE_TOTAL,
          ],
        }}
      >
        État facture
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="numerosRecus" style={{ width: 150 }}>
        N° de(s) reçu(s)
        <br />
        rattaché(s)
      </ListeTable.Column>
    </>
  );
};

export default FacturesListeTableHeaderGlobale;
